import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'

export const ARGENTINA_PHONE_CODE = '+549'
export const ARGENTINA_PHONE_MAX_LENGTH = 10
export const OTHER_PHONE_MAX_LENGTH = 15
export const ARGENTINA_PHONE_HELPER =
  'El teléfono debe ir sin 0 inicial ni 15.'

const fetchPhoneCountries = async () => {
  const response = await axios.get(`${CLIENTES_ENDPOINT}/countries`)
  const countries = response?.data?.data || []
  return countries.filter((c) => c.phone_prefix)
}

let phoneCountriesPromise = null

const getPhoneCountries = () => {
  if (!phoneCountriesPromise) {
    phoneCountriesPromise = fetchPhoneCountries().catch((error) => {
      phoneCountriesPromise = null
      throw error
    })
  }
  return phoneCountriesPromise
}

/**
 * Si falla el request vuelve [+549], para no dejar el formulario inutilizable.
 */
export const fetchPhoneCountryCodes = async () => {
  try {
    const countries = await getPhoneCountries()
    return countries.map((c) => c.phone_prefix)
  } catch (error) {
    console.error('Error fetching phone country codes', error)
    return [ARGENTINA_PHONE_CODE]
  }
}

export const fetchPhoneCountryOptions = async () => {
  const countries = await getPhoneCountries()
  return countries
    .map((c) => ({
      value: c.phone_prefix,
      nombre: c.nombre,
      label: `${c.nombre} (${c.phone_prefix})`,
      id: c.id,
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es', { sensitivity: 'base' }))
}

export const getPhoneMaxLength = (phoneCountryCode) =>
  !phoneCountryCode || phoneCountryCode === ARGENTINA_PHONE_CODE
    ? ARGENTINA_PHONE_MAX_LENGTH
    : OTHER_PHONE_MAX_LENGTH

export const isArgentinaPhoneCode = (phoneCountryCode) =>
  !phoneCountryCode || phoneCountryCode === ARGENTINA_PHONE_CODE

/**
 * Une codigo pais + numero nacional para persistir en BD.
 */
export const composePhone = (phoneCountryCode, nationalNumber) => {
  if (nationalNumber == null || nationalNumber === '') return null
  const code = phoneCountryCode || ARGENTINA_PHONE_CODE
  const normalizedCode = code.startsWith('+') ? code : `+${code}`
  const national = String(nationalNumber).replace(/\D/g, '')
  if (!national) return null
  return `${normalizedCode}${national}`
}

/**
 * Separa un telefono completo en codigo pais + numero nacional.
 * @param {string} fullPhone
 * @param {string[]} countryCodes lista de phone_prefix (ej. ['+549','+55'])
 */
export const splitPhone = (fullPhone, countryCodes = []) => {
  if (!fullPhone) {
    return { phoneCountryCode: ARGENTINA_PHONE_CODE, phone: '' }
  }

  let digits = String(fullPhone).replace(/\D/g, '')
  if (!digits) {
    return { phoneCountryCode: ARGENTINA_PHONE_CODE, phone: '' }
  }

  const withPlus = `+${digits}`
  const codes = [...countryCodes]
    .filter(Boolean)
    .map((c) => (String(c).startsWith('+') ? String(c) : `+${c}`))
    .sort((a, b) => b.length - a.length)

  for (const code of codes) {
    if (withPlus.startsWith(code)) {
      return {
        phoneCountryCode: code,
        phone: withPlus.slice(code.length),
      }
    }
  }

  if (withPlus.startsWith(ARGENTINA_PHONE_CODE)) {
    return {
      phoneCountryCode: ARGENTINA_PHONE_CODE,
      phone: withPlus.slice(ARGENTINA_PHONE_CODE.length),
    }
  }

  if (withPlus.startsWith('+54')) {
    return {
      phoneCountryCode: ARGENTINA_PHONE_CODE,
      phone: withPlus.slice(3),
    }
  }

  return {
    phoneCountryCode: ARGENTINA_PHONE_CODE,
    phone: digits,
  }
}

// El maxLength del input no recorta el valor ya cargado.
export const truncatePhoneForCountryCode = (phone, phoneCountryCode) => {
  if (!phone) return phone
  const maxLength = getPhoneMaxLength(phoneCountryCode)
  const value = String(phone)
  return value.length > maxLength ? value.slice(0, maxLength) : phone
}
